import Cookies from 'js-cookie';

import { onDocumentReady } from '@prairielearn/browser-utils';

onDocumentReady(() => {
  ///////////////////////////////////////////////////////////////////////////
  // Developer-mode user switching

  document.querySelector('#dev-user-admin')?.addEventListener('click', () => {
    Cookies.set('pt_requested_uid', 'dev-admin@example.com', { path: '/' });
    location.reload();
  });

  document.querySelector('#dev-user-owner')?.addEventListener('click', () => {
    Cookies.set('pt_requested_uid', 'dev-owner@example.com', { path: '/' });
    location.reload();
  });

  document.querySelector('#dev-user-editor')?.addEventListener('click', () => {
    Cookies.set('pt_requested_uid', 'dev-editor@example.com', { path: '/' });
    location.reload();
  });

  document.querySelector('#dev-user-proctor')?.addEventListener('click', () => {
    Cookies.set('pt_requested_uid', 'dev-proctor@example.com', { path: '/' });
    location.reload();
  });

  document.querySelector('#dev-user-student')?.addEventListener('click', () => {
    Cookies.set('pt_requested_uid', 'dev-student@example.com', { path: '/' });
    location.reload();
  });

  document.querySelector('#dev-user-custom-form')?.addEventListener('submit', (event) => {
    event.preventDefault();
    const uid = document.querySelector<HTMLInputElement>('#dev-user-custom-input')?.value.trim();
    if (!uid) return;
    Cookies.set('pt_requested_uid', uid, { path: '/' });
    location.reload();
  });

  ///////////////////////////////////////////////////////////////////////////
  // Developer-mode fixed date changes

  document.querySelector('#js-fixed-date-set')?.addEventListener('click', () => {
    Cookies.set(
      'pt_requested_fixed_date',
      document.querySelector<HTMLInputElement>('#js-fixed-date-input')?.value ?? '',
      { path: '/' },
    );
    location.reload();
  });

  document.querySelector('#js-fixed-date-set')?.addEventListener('click', () => {
    Cookies.set(
      'pt_requested_fixed_date',
      document.querySelector<HTMLInputElement>('#js-fixed-date-input')?.value ?? '',
      { path: '/' },
    );
    location.reload();
  });

  document.querySelector('#js-fixed-date-decrement')?.addEventListener('click', () => {
    Cookies.set('pt_requested_fixed_date', 'decrement', { path: '/' });
    location.reload();
  });

  document.querySelector('#js-fixed-date-increment')?.addEventListener('click', () => {
    Cookies.set('pt_requested_fixed_date', 'increment', { path: '/' });
    location.reload();
  });
});
